const controlList = {
  CTRL_LOGIN: 'login',
  CTRL_ME: 'me',
  CTRL_CAA204: 'caa204',
  CTRL_CURRENT_EMPLOYER: 'currentEmployer',
  CTRL_CLAIM: 'claim',
  CTRL_CLAIM_INQUIRY_REQUEST: 'claimInquiryRequest',
  CTRL_INVOICE_INQUIRY: 'invoiceInquiry',
  CTRL_DOCUMENT: 'document',
  CTRL_EMPLOYEE: 'employee',
  CTRL_ID_CARD_EMAIL_REMOVE: 'memberCard',
  CTRL_ID_CARD_EMAIL: 'memberIdCard',
  CTRL_EMPLOYER: 'employer',
  CTRL_GROUP: 'group',
  CTRL_INVOICE: 'invoice',
  CTRL_INVOICE_PDF: 'invoicePdf',
  CTRL_NOTIFICATION: 'notification',
  CTRL_REPORT: 'report',
  CTRL_ROLE: 'role',
  CTRL_USERTYPE: 'userType',
  CTRL_USER: 'domainUser',
  CTRL_INVITATION: 'invitation',
  CTRL_PROVIDER_GET: 'providersLink',
  CTRL_PROVIDER_GET_REMOVE: 'providers',
  CTRL_ENROLLMENT_GET: 'enrollment',
  CTRL_DYNAMIC_REPORTS_GET: 'dynamicReports',
  CTRL_SPLIT: 'split',
  FROM_INSTANCE: 'instance',
  CTRL_TERMS_AND_CONDITIONS_ACK: 'termsAndConditionsAck',
  CTRL_HIPAA_FLAG_ACK: 'hipaaFlagAck'
};

const getControlKey = ctrl => controlList[ctrl];
const hasControl = ctrl => getControlKey(ctrl) !== undefined;
const retrieveControl = (ctrl, action, allControls = {}, member) => {
  const control = allControls[getControlKey(ctrl)];
  let result = {};

  // TODO: Delete down to END-DELETE when 172616 is deployed to production as per 172487
  let plansMedical = [];
  if (member) {
    plansMedical = member.plans.filter(el => el.planType === 'Medical');
  }

  if (control && control['@controls'][action] && member && plansMedical.length > 0) {
    result = control['@controls'][action];
    if (member.mailingAddress.postCode && plansMedical[0].vitalsNetwork) {
      var postCode = member.mailingAddress.postCode;
      var vitalsNetwork = plansMedical[0].vitalsNetwork;
    }
    let newHref = result.href.replace('{PostCode}', postCode).replace('{NetworkId}', vitalsNetwork);
    result = { href: newHref, method: 'GET' };
  }
  // TODO: END-DELETE
  else if (control && control['@controls'][action]) {
    result = control['@controls'][action];
  }
  return result;
};

export default {
  getControlKey,
  hasControl,
  retrieveControl
};
